import React, { useMemo, useState } from "react";

const SeatAvailability = ({
  serviceData,
  loading,
  onSeatSelect,
  selectedPaxType,
  selectedPaxIndex,
  selectedSeat,          // { seatNo, price }
  seatSelections,        // ✅ ALL selections
  activeSegmentKey,      // ✅ CURRENT segment
}) => {
  const seats = serviceData?.deckData?.seats || [];
  const [hoveredSeat, setHoveredSeat] = useState(null);

  /* ---------------- HELPERS ---------------- */
  const getSeatType = (index, total) => {
    if (index === 0 || index === total - 1) return "W";
    if (index === 1 || index === total - 2) return "A";
    return "M";
  };

  /* ---------------- OCCUPIED SEATS ---------------- */
const occupiedSeats = useMemo(() => {
  const set = new Set();
  const segmentSeats = seatSelections?.[activeSegmentKey] || {};

  Object.values(segmentSeats).forEach((paxGroup) => {
    Object.values(paxGroup).forEach((seat) => {
      if (seat?.seatCode) {
        set.add(seat.seatCode);
      }
    });
  });

  if (selectedSeat?.seatCode) {
    set.delete(selectedSeat.seatCode);
  }

  return set;
}, [seatSelections, activeSegmentKey, selectedSeat]);
  /* ---------------- CLICK ---------------- */
const handleSeatClick = (seat) => {
  if (!selectedPaxType || selectedPaxIndex === null) {
    alert("Please select passenger first");
    return;
  }

  if (seat.booked) return;

  const isSameSeat = selectedSeat?.seatCode === seat.code;

  // REMOVE
  if (isSameSeat) {
    onSeatSelect(selectedPaxType, selectedPaxIndex, { remove: true });
    return;
  }

  if (occupiedSeats.has(seat.code)) return;

  // ADD
  onSeatSelect(selectedPaxType, selectedPaxIndex, {
    seatCode: seat.code,
    displaySeatNo: seat.seatNo,
    price: seat.amount || 0,
  });
};


  /* ---------------- GRID ---------------- */
  const seatGrid = useMemo(() => {
    const grid = {};
    seats.forEach((seat) => {
      const row = seat.seatPos?.y;
      const col = seat.seatPos?.x;
      if (row == null || col == null) return;
      if (!grid[row]) grid[row] = [];
      grid[row][col] = seat;
    });
    return grid;
  }, [seats]);

  /* ---------------- RENDER SEAT ---------------- */
  const renderSeat = (seat, index, total, isExitRow) => {
   const isSelected = selectedSeat?.seatCode === seat.code;
const isOccupied = occupiedSeats.has(seat.code);
    const disabled = seat.booked || isOccupied;
    const seatType = getSeatType(index, total);

    return (
      <div key={seat.code} style={{ position: "relative" }}>
        <button
          type="button"
          disabled={disabled}
          onClick={() => handleSeatClick(seat)}
          onMouseEnter={() => setHoveredSeat(seat)}
          onMouseLeave={() => setHoveredSeat(null)}
          style={{
            width: 48,
            height: 48,
            backgroundColor: seat.booked
              ? "#adb5bd"
              : isSelected
                ? "#198754"
                : isOccupied
                  ? "#6c757d"
                  : isExitRow
                    ? "#ffc107"
                    : "#0d6efd",
            color: "#fff",
            borderRadius: 6,
            border: isSelected ? "2px solid #14532d" : "1px solid #dee2e6",
            fontWeight: 600,
            cursor: disabled ? "not-allowed" : "pointer",
            fontSize: 13,
            padding:0,
            textAlign:"center"
          }}
        >
          {/* {seat.seatNo}
          <div style={{ fontSize: 10 }}>{seatType}</div> */}
          {/* {seat.seatNo}
          
          {Number(seat.amount) > 0 && (
            <div style={{ fontSize: 9 }}>
              ₹ {seat.amount}
            </div>
          )} */}
          {isSelected ? (
  <span style={{ fontSize: 18 }}>✔</span>
) : (
  seat.seatNo
)}

{!isSelected && Number(seat.amount) > 0 && (
  <div style={{ fontSize: 9 }}>
    ₹ {seat.amount}
  </div>
)}
        </button>

        {hoveredSeat?.seatNo === seat.seatNo && (
          <div
            style={{
              position: "absolute",
              top: "-65px",
              left: "50%",
              transform: "translateX(-50%)",
              background: "#000",
              color: "#fff",
              padding: "6px 8px",
              fontSize: 12,
              borderRadius: 4,
              whiteSpace: "nowrap",
              zIndex: 10,
            }}
          >
            <div><strong>Seat:</strong> {seat.seatNo}</div>
            <div><strong>Type:</strong> {seatType}</div>
            <div>
              <strong>Status:</strong>{" "}
              {isOccupied ? "Selected by another pax" : seat.amount ? `₹ ${seat.amount}` : "Free"}
            </div>
          </div>
        )}
      </div>
    );
  };

  /* ---------------- JSX ---------------- */
  if (loading) {
    return <p className="text-center"><span className="loader" /></p>;
  }

  if (!seats.length) {
    return (
      <p className="text-danger text-center">
        Seat selection is not available for this flight
      </p>
    );
  }

  return (

    <div className="row"> {/* Seat Map */}
      <div className="col-md-12 Seat_flow">
        <div class="cockpit">
          <div class="cockpit-top">
            <img src="/assets/images/cockpit-top.png" alt="Cockpit" /></div>
          <div class="front nws">Front</div>
        </div>

        <div className="col-md-12 seat-map">
          <div class="d-flex exit"> <span>Exit</span> <span>Exit</span>
          </div>
          {Object.keys(seatGrid)
            .sort((a, b) => Number(a) - Number(b))
            .map((rowKey) => {
              const rowSeats = seatGrid[rowKey];
              const aisleIndex = Math.floor(rowSeats.length / 2);
              const isExitRow = [12, 13].includes(Number(rowKey));

              return (
                <div
                  key={rowKey}
                  style={{ display: "flex", justifyContent: "center", marginBottom: 14 }}
                >
                  <div style={{ display: "flex", gap: 6 }}>
                    {rowSeats.slice(0, aisleIndex).map(
                      (s, i) => s && renderSeat(s, i, rowSeats.length, isExitRow)
                    )}
                  </div>

                  <div style={{ width: 50 }} />

                  <div style={{ display: "flex", gap: 6 }}>
                    {rowSeats.slice(aisleIndex).map(
                      (s, i) => s && renderSeat(s, i + aisleIndex, rowSeats.length, isExitRow)
                    )}
                  </div>
                </div>
              );
            })}
          <div class="d-flex exit"> <span>Exit</span> <span>Exit</span> </div>
        </div>
      </div>
    </div>
  );
};

export default SeatAvailability;
